import { orvalClient } from "@api/client";
import type { AxiosRequestConfig, AxiosResponse } from "axios";

export const customInstance = async <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> => {
  const response: AxiosResponse<T> = await orvalClient.request<T>({
    ...config,
    ...(options ?? {}),
  });
  return response.data;
};
